"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Password;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _beNovativeKit = _interopRequireDefault(require("@bit/be-novative.kit.checkbox"));

var _beNovativeKit2 = _interopRequireDefault(require("@bit/be-novative.kit.input"));

var _PasswordModule = _interopRequireDefault(require("./Password.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// todo use future input group
Password.propTypes = {
  input: _propTypes.default.object,
  meta: _propTypes.default.object,
  showLabel: _propTypes.default.string
};
Password.defaultProps = {
  input: {},
  meta: {}
};

function Password(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      showLabel = _ref.showLabel;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      revealPassword = _useState2[0],
      setRevealPassword = _useState2[1];

  var handleReveal = (0, _react.useCallback)(function () {
    setRevealPassword(function (isRevealed) {
      return !isRevealed;
    });
  }, []);
  return _react.default.createElement("div", {
    className: _PasswordModule.default.Wrapper
  }, _react.default.createElement(_beNovativeKit2.default, {
    type: revealPassword ? 'text' : 'password',
    meta: meta,
    input: input
  }), _react.default.createElement("span", {
    className: _PasswordModule.default.ShowBtn
  }, _react.default.createElement(_beNovativeKit.default, {
    input: {
      checked: revealPassword,
      onChange: handleReveal
    }
  }, showLabel)));
}

//# sourceMappingURL=Password.js.map